import React from 'react';
import { useTranslation } from 'react-i18next';

export const OrModule: React.FC = () => {
	const { t } = useTranslation();
	return (
		<div className="flex flex-row w-full">
			<div className="w-full h-[1px] bg-gray-100 mt-[6px]" />
			<div className="text-gray-100 text-center justify-start text-paragraph-xs font-normal leading-none mx-2 uppercase">
				{t('registrationMethods_or')}
			</div>
			<div className="w-full h-[1px] bg-gray-100 mt-[6px]" />
		</div>
	);
};
